import { Badge, chakra } from '@chakra-ui/react'
import ComponentProps from '../../types/ComponentProps'

export interface PlatformBannerProps extends ComponentProps {
  environmentName?: string
  appVersion: string
  show?: boolean
}

/**
 * Represents a PlatformBanner component, which renders platform information in pre-production environments.
 * @param environmentName - The environment name, loaded from PRESENT_ENVIRONMENT environment variable if omitted.
 * @param appVersion - The application version.
 * @param show - Whether to show or hide the banner.
 */
export default chakra(PlatformBanner)

function PlatformBanner({
  environmentName,
  appVersion,
  show,
  ...props
}: PlatformBannerProps) {
  environmentName =
    environmentName || process.env.PRESENT_ENVIRONMENT || 'local'
  show = show ?? environmentName !== 'prod'

  return (
    <Badge
      position='fixed'
      bottom='0'
      textTransform='none'
      fontSize='0.95rem'
      display={show ? 'block' : 'none'}
      m={4}
      role='banner'
      {...props}
    >
      ⭕ {environmentName} v{appVersion}
    </Badge>
  )
}
